export default __webpack_public_path__ + "static/media/SixtemaTinexta-Original.fef9f5f9.png";